import React, { useEffect, useState } from 'react';
import { ShieldCheck, Lock, CreditCard, RotateCcw, CheckCircle2 } from 'lucide-react';
export function PricingSection() {
  const [selectedPlan, setSelectedPlan] = useState('basico');
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        }
        if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section id="compra" className="w-full bg-[#111111] py-16 px-4 flex flex-col items-center font-sans" data-id="element-97">
      <div className="max-w-3xl w-full" data-id="element-98">
        <div className="text-center mb-8" data-id="element-99">
          <h2 className="text-2xl md:text-3xl font-bold text-yellow-500 mb-2" data-id="element-100">
            🔥 ESTA ES UNA OFERTA LIMITADA
          </h2>
          <p className="text-white font-bold text-lg mb-6" data-id="element-101">
            ⏳ EL PRECIO DE LANZAMIENTO TERMINA EN:{' '}
            <span className="text-red-500 font-mono text-xl" data-id="element-102">
              {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
              {formatTime(timeLeft.seconds)}
            </span>
          </p>
          <h3 className="text-xl md:text-2xl font-bold text-white flex items-center justify-center gap-2" data-id="element-103">
            Elegí cómo querés empezar
          </h3>
        </div>

        <div className="space-y-4" data-id="element-104">
          {/* Plan Básico */}
          <div onClick={() => setSelectedPlan('basico')} className={`cursor-pointer rounded-2xl p-5 border-2 transition-all duration-300 ${selectedPlan === 'basico' ? 'border-gray-400 bg-[#1A1A1A]' : 'border-gray-800 bg-[#161616] hover:border-gray-700'}`} data-id="element-105">
            <div className="flex items-start justify-between" data-id="element-106">
              <div className="flex items-start gap-4" data-id="element-107">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'basico' ? 'border-white' : 'border-gray-500'}`} data-id="element-108">
                  {selectedPlan === 'basico' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-109" />}
                </div>
                <div data-id="element-110">
                  <h3 className="text-xl font-bold text-white flex items-center gap-2" data-id="element-111">
                    PLAN BÁSICO
                  </h3>

                  <div className={`overflow-hidden transition-all duration-300 ease-in-out ${selectedPlan === 'basico' ? 'max-h-64 opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-112">
                    <p className="text-gray-400 text-sm mb-2 font-bold" data-id="element-113">
                      Incluye:
                    </p>
                    <ul className="space-y-1.5 text-sm text-gray-300 grid grid-cols-2 gap-x-4" data-id="element-114">
                      <li className="flex items-center gap-2" data-id="element-115">
                        <div className="w-1.5 h-1.5 bg-blue-400 rounded-full" data-id="element-116"></div>{' '}
                        Tomo 1
                      </li>
                      <li className="flex items-center gap-2" data-id="element-117">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full" data-id="element-118"></div>{' '}
                        Tomo 2
                      </li>
                      <li className="flex items-center gap-2" data-id="element-119">
                        <div className="w-1.5 h-1.5 bg-orange-400 rounded-full" data-id="element-120"></div>{' '}
                        Tomo 3
                      </li>
                      <li className="flex items-center gap-2" data-id="element-121">
                        <div className="w-1.5 h-1.5 bg-purple-400 rounded-full" data-id="element-122"></div>{' '}
                        Tomo 4
                      </li>
                      <li className="flex items-center gap-2" data-id="element-123">
                        <div className="w-1.5 h-1.5 bg-pink-400 rounded-full" data-id="element-124"></div>{' '}
                        Tomo 5
                      </li>
                      <li className="flex items-center gap-2 font-bold text-white" data-id="element-125">
                        <div className="w-1.5 h-1.5 bg-red-400 rounded-full" data-id="element-126"></div>{' '}
                        TODOS LOS BONOS
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="text-right shrink-0" data-id="element-127">
                <p className="text-2xl md:text-3xl font-bold text-white" data-id="element-128">
                  $19.990{' '}
                  <span className="text-sm font-normal text-gray-400" data-id="element-129">ARS</span>
                </p>
              </div>
            </div>
          </div>

          {/* Plan Completo (Best Value) */}
          <div onClick={() => setSelectedPlan('completo')} className={`cursor-pointer rounded-2xl p-5 border-2 transition-all duration-300 ${selectedPlan === 'completo' ? 'border-yellow-500 bg-[#1A1A1A] shadow-[0_0_15px_rgba(234,179,8,0.15)]' : 'border-gray-800 bg-[#161616] hover:border-gray-700'}`} data-id="element-130">
            <div className="flex items-start justify-between" data-id="element-131">
              <div className="flex items-start gap-4" data-id="element-132">
                <div className={`mt-1 w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPlan === 'completo' ? 'border-yellow-500' : 'border-gray-500'}`} data-id="element-133">
                  {selectedPlan === 'completo' && <div className="w-2.5 h-2.5 rounded-full bg-yellow-500" data-id="element-134" />}
                </div>
                <div data-id="element-135">
                  <h3 className="text-xl font-bold text-yellow-500 flex items-center gap-2" data-id="element-136">
                    PLAN COMPLETO (MÁS ELEGIDO)
                  </h3>

                  <div className={`overflow-hidden transition-all duration-300 ease-in-out ${selectedPlan === 'completo' ? 'max-h-96 opacity-100 mt-4' : 'max-h-0 opacity-0'}`} data-id="element-137">
                    <p className="text-gray-400 text-sm mb-2 font-bold" data-id="element-138">
                      Incluye:
                    </p>
                    <ul className="space-y-1.5 text-sm text-gray-300 grid grid-cols-1 md:grid-cols-2 gap-x-4" data-id="element-139">
                      <li className="flex items-center gap-2" data-id="element-140">
                        <div className="w-1.5 h-1.5 bg-blue-400 rounded-full" data-id="element-141"></div>{' '}
                        Tomo 1
                      </li>
                      <li className="flex items-center gap-2" data-id="element-142">
                        <div className="w-1.5 h-1.5 bg-green-400 rounded-full" data-id="element-143"></div>{' '}
                        Tomo 2
                      </li>
                      <li className="flex items-center gap-2" data-id="element-144">
                        <div className="w-1.5 h-1.5 bg-orange-400 rounded-full" data-id="element-145"></div>{' '}
                        Tomo 3
                      </li>
                      <li className="flex items-center gap-2" data-id="element-146">
                        <div className="w-1.5 h-1.5 bg-purple-400 rounded-full" data-id="element-147"></div>{' '}
                        Tomo 4
                      </li>
                      <li className="flex items-center gap-2" data-id="element-148">
                        <div className="w-1.5 h-1.5 bg-pink-400 rounded-full" data-id="element-149"></div>{' '}
                        Tomo 5
                      </li>
                      <li className="flex items-center gap-2 font-bold text-white" data-id="element-150">
                        <div className="w-1.5 h-1.5 bg-red-400 rounded-full" data-id="element-151"></div>{' '}
                        TODOS LOS BONOS
                      </li>
                      <li className="flex items-center gap-2 text-yellow-500 font-bold mt-2 col-span-1 md:col-span-2" data-id="element-152">
                        <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full" data-id="element-153"></div>{' '}
                        LONCHERA KIDS ESCOLAR
                      </li>
                      <li className="flex items-center gap-2 text-yellow-500 font-bold col-span-1 md:col-span-2" data-id="element-154">
                        <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full" data-id="element-155"></div>{' '}
                        FREEZER INTELIGENTE SIN TACC
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="text-right shrink-0" data-id="element-156">
                <p className="text-2xl md:text-3xl font-bold text-yellow-500" data-id="element-157">
                  $29.990{' '}
                  <span className="text-sm font-normal text-gray-400" data-id="element-158">ARS</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Social Proof Banner */}
        <div className="mt-6 bg-[#1A1A1A] border-l-4 border-yellow-500 p-4 rounded-r-lg flex items-start gap-3" data-id="element-159">
          <span className="text-xl" data-id="element-160">🔥</span>
          <p className="text-gray-300 text-sm md:text-base font-bold" data-id="element-161">
            Es la opción más elegida porque te resuelve TODO
          </p>
        </div>

        {/* Buy Button */}
        <div className="mt-8" data-id="element-162">
          <a href={selectedPlan === 'basico' ? 'https://checkout.impulsodigitalx.shop/cart/45858009350305:1' : 'https://checkout.impulsodigitalx.shop/cart/45858012266657:1'} className="w-full block text-center bg-[#E52B2B] hover:bg-[#D42424] text-white font-black text-xl md:text-2xl py-4 px-8 rounded-xl shadow-[0_4px_20px_rgba(229,43,43,0.4)] transform hover:-translate-y-1 transition-all duration-300 uppercase tracking-wide" data-id="element-163">
            {selectedPlan === 'basico' ? '👉 QUIERO EL PLAN BÁSICO' : '👉 QUIERO EL PLAN COMPLETO'}
          </a>

          {/* Trust Badges */}
          <div className="mt-6 flex flex-wrap justify-center gap-6 text-gray-500" data-id="element-164">
            <div className="flex flex-col items-center gap-1" data-id="element-165">
              <Lock size={24} data-id="element-166" />
              <span className="text-[10px] uppercase font-bold" data-id="element-167">
                Pago Seguro
              </span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-168">
              <RotateCcw size={24} data-id="element-169" />
              <span className="text-[10px] uppercase font-bold" data-id="element-170">
                Garantía 7 Días
              </span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-171">
              <CreditCard size={24} data-id="element-172" />
              <span className="text-[10px] uppercase font-bold" data-id="element-173">
                Tarjetas / Efectivo
              </span>
            </div>
            <div className="flex flex-col items-center gap-1" data-id="element-174">
              <ShieldCheck size={24} data-id="element-175" />
              <span className="text-[10px] uppercase font-bold" data-id="element-176">
                Privacidad
              </span>
            </div>
          </div>
        </div>

        {/* Comparison Section */}
        <div className="mt-16 bg-[#1A1A1A] rounded-2xl p-6 md:p-8 border border-gray-800" data-id="element-177">
          <h3 className="text-2xl font-bold text-white text-center mb-8" data-id="element-178">
            ¿Qué incluye cada versión?
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-179">
            <div className="bg-[#111111] p-6 rounded-xl border border-gray-800" data-id="element-180">
              <h4 className="text-xl font-bold text-white mb-4 text-center" data-id="element-181">
                PLAN BÁSICO
              </h4>
              <ul className="space-y-3" data-id="element-182">
                <li className="flex items-center gap-2 text-gray-300" data-id="element-183">
                  <CheckCircle2 className="text-green-500 shrink-0" size={20} data-id="element-184" />{' '}
                  Base del sistema
                </li>
                <li className="flex items-center gap-2 text-gray-300" data-id="element-185">
                  <CheckCircle2 className="text-green-500 shrink-0" size={20} data-id="element-186" />{' '}
                  Organización inicial
                </li>
                <li className="flex items-center gap-2 text-gray-300" data-id="element-187">
                  <CheckCircle2 className="text-green-500 shrink-0" size={20} data-id="element-188" />{' '}
                  Primeros resultados
                </li>
              </ul>
            </div>

            <div className="bg-[#111111] p-6 rounded-xl border border-yellow-500/50 relative" data-id="element-189">
              <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-yellow-500 text-black text-xs font-bold px-3 py-1 rounded-full" data-id="element-190">
                RECOMENDADO
              </div>
              <h4 className="text-xl font-bold text-yellow-500 mb-4 text-center" data-id="element-191">
                PLAN COMPLETO
              </h4>
              <ul className="space-y-3" data-id="element-192">
                <li className="flex items-center gap-2 text-gray-300" data-id="element-193">
                  <CheckCircle2 className="text-yellow-500 shrink-0" size={20} data-id="element-194" />{' '}
                  Sistema completo
                </li>
                <li className="flex items-center gap-2 text-gray-300" data-id="element-195">
                  <CheckCircle2 className="text-yellow-500 shrink-0" size={20} data-id="element-196" />{' '}
                  Menús listos
                </li>
                <li className="flex items-center gap-2 text-gray-300" data-id="element-197">
                  <CheckCircle2 className="text-yellow-500 shrink-0" size={20} data-id="element-198" />{' '}
                  Organización total
                </li>
                <li className="flex items-center gap-2 text-gray-300" data-id="element-199">
                  <CheckCircle2 className="text-yellow-500 shrink-0" size={20} data-id="element-200" />{' '}
                  Ahorro optimizado
                </li>
                <li className="flex items-center gap-2 text-gray-300" data-id="element-201">
                  <CheckCircle2 className="text-yellow-500 shrink-0" size={20} data-id="element-202" />{' '}
                  Bonos incluidos
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}